const DAY_MS = 86400000;
// Countdown label for a remaining duration in milliseconds: whole days while more than a day is
// left, then a hh:mm:ss tick, exactly like the legacy project card counter (ProjectTimeLeft).
export const formatTimeLeft = (timeLeft) => {
    const remaining = Math.max(0, timeLeft);
    const days = Math.floor(remaining / DAY_MS);
    if (days > 0) {
        return `${days} ${days === 1 ? 'day' : 'days'}`;
    }
    const hours = Math.floor((remaining / 3600000) % 24);
    const minutes = Math.floor((remaining / 60000) % 60);
    const seconds = Math.floor((remaining / 1000) % 60);
    return [hours, minutes, seconds].map(part => String(part).padStart(2, '0')).join(':');
};
